import React, { useState } from 'react';

export default function DisenoDesarrolloForm({ onGuardar, onCancelar }) {
  const [form, setForm] = useState({
    nombre: '',
    cliente: '',
    ot: '',
    origen: 'ot',
    disenador: '',
    formato: '',
    material: '',
    colores: '',
    acabado: '',
    tirada: '',
    estado: 'borrador',
    notas: '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleGuardar = () => {
    if (!form.nombre.trim()) return alert('El nombre del proyecto es obligatorio');
    onGuardar(form);
  };

  const inputStyle = {
    width: '100%', padding: '8px 10px', borderRadius: '8px',
    border: '1px solid #E5E7EB', fontSize: '13px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Inter, sans-serif',
  };
  const labelStyle = { fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' };
  const sectionTitle = { fontSize: '12px', fontWeight: '700', color: '#1C3FAA', margin: '16px 0 10px', paddingBottom: '6px', borderBottom: '1px solid #E8E9F6' };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', borderRadius: '16px', width: '540px', maxHeight: '90vh', overflowY: 'auto', padding: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>✏️ Nuevo proyecto</h2>
          <button onClick={onCancelar} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>
        <p style={{ fontSize: '12px', color: '#9CA3AF', margin: '0 0 4px' }}>ISO 9001 §8.3 · Diseño y Desarrollo</p>

        {/* Datos generales */}
        <div style={sectionTitle}>Datos generales</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Nombre del proyecto *</label>
            <input style={inputStyle} placeholder="Ej: Caja Cereal Primavera" value={form.nombre} onChange={e => set('nombre', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Cliente</label>
            <input style={inputStyle} placeholder="Ej: Arcor SA" value={form.cliente} onChange={e => set('cliente', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Diseñador responsable</label>
            <input style={inputStyle} placeholder="Nombre completo" value={form.disenador} onChange={e => set('disenador', e.target.value)} />
          </div>
        </div>

        {/* Origen */}
        <div style={sectionTitle}>Origen del proyecto</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '12px' }}>
          {[{ k: 'ot', label: '📋 Orden de Trabajo', sub: 'Viene de un pedido de cliente' },
            { k: 'interno', label: '🏭 Solicitud interna', sub: 'Iniciativa propia' }].map(o => (
            <button key={o.k} onClick={() => set('origen', o.k)}
              style={{ padding: '10px 12px', borderRadius: '10px', border: `1.5px solid ${form.origen === o.k ? '#1C3FAA' : '#E5E7EB'}`, background: form.origen === o.k ? '#E8E9F6' : 'white', cursor: 'pointer', textAlign: 'left' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', color: form.origen === o.k ? '#1C3FAA' : '#374151' }}>{o.label}</div>
              <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{o.sub}</div>
            </button>
          ))}
        </div>
        {form.origen === 'ot' && (
          <div>
            <label style={labelStyle}>Número de OT vinculada</label>
            <input style={inputStyle} placeholder="Ej: 1284" value={form.ot} onChange={e => set('ot', e.target.value)} />
          </div>
        )}

        {/* Ficha técnica */}
        <div style={sectionTitle}>Ficha técnica</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div>
            <label style={labelStyle}>Formato / dimensiones</label>
            <input style={inputStyle} placeholder="Ej: 350×250×80 mm" value={form.formato} onChange={e => set('formato', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Material / sustrato</label>
            <input style={inputStyle} placeholder="Ej: Cartulina SBS 300g" value={form.material} onChange={e => set('material', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Colores de impresión</label>
            <input style={inputStyle} placeholder="Ej: CMYK + Pantone 186" value={form.colores} onChange={e => set('colores', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Acabado</label>
            <input style={inputStyle} placeholder="Ej: Barniz UV selectivo" value={form.acabado} onChange={e => set('acabado', e.target.value)} />
          </div>
          <div>
            <label style={labelStyle}>Tirada</label>
            <input style={inputStyle} placeholder="Ej: 50.000 unidades" value={form.tirada} onChange={e => set('tirada', e.target.value)} />
          </div>
        </div>

        {/* Notas */}
        <div style={sectionTitle}>Notas adicionales</div>
        <textarea
          style={{ ...inputStyle, minHeight: '70px', resize: 'vertical' }}
          placeholder="Observaciones, referencias, requisitos especiales..."
          value={form.notas}
          onChange={e => set('notas', e.target.value)}
        />

        {/* Botones */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button onClick={onCancelar}
            style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>
            Cancelar
          </button>
          <button onClick={handleGuardar}
            style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#1C3FAA', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
            Crear proyecto
          </button>
        </div>
      </div>
    </div>
  );
}
